import React from 'react';

export const NewsVideoPageLoadingUI = (): JSX.Element => {

    return (
        <>
            <div className='news-page-wrapper'>
                <div className='camera-nav-bar'>
                    <div className='camera-nav-tabs'>
                        <div className='camera-nav-tab'>News</div>
                        <div className='camera-nav-tab'>Videos</div>
                    </div>
                </div>
                <div className='newslanding-page-wrapper'>
                    <div className='newslanding-top-stories-container'>
                        <div className='newslanding-top-stories-title'>
        Top News Stories
                        </div>
                        <div className='newslanding-top-stories-news-landing-wrapper not-mobile'>
                            <div className='newslanding-top-stories-news-landing-container'>
                                <div className='newslanding-top-stories-news-landing-left-container'>
                                    <div className='newslanding-top-stories-news-landing-left-content'></div>
                                </div>
                                <div className='newslanding-top-stories-news-landing-right-container'>
                                    <div className='newslanding-top-stories-news-landing-right-content'>
                                        <div className='newslanding-news-card-container'></div>
                                        <div className='newslanding-news-card-container'></div>
                                        <div className='newslanding-news-card-container'></div>
                                    </div>
                                    <div className='newslanding-newsScreen-ad display-on-tablet-only'>
                                        <div className='newslanding-top-ad-container'></div>
                                    </div>
                                </div>
                                <div className='newslanding-newsScreen-ad display-on-desktop-only'>
                                    <div className='newslanding-top-ad-container'></div>
                                </div>
                            </div>
                        </div>
                        <div className='newslanding-top-stories-news-landing-wrapper display-on-mobile-only'>
                            <div className='newslanding-top-stories-news-landing-container'>
                                <div className='newslanding-top-stories-news-landing-left-container'>
                                    <div className='newslanding-top-stories-news-landing-left-content'></div>
                                </div>
                                <div className='newslanding-top-stories-news-landing-right-container'>
                                    <div className='newslanding-top-stories-news-landing-right-content'>
                                        <div className='newslanding-news-card-container'></div>
                                        <div className='newslanding-news-card-container'></div>
                                        <div className='newslanding-news-card-container'></div>
                                    </div>
                                    <div className='newslanding-newsScreen-ad'>
                                        <div className='newslanding-top-ad-container'></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='newslanding-latest-news-wrapper'>
                        <div className='newslanding-latest-news-title'>Latest News</div>

                        <div className='newslanding-latest-news-container display-on-desktop-only'>
                            <div className='newslanding-top-latest-news-container'>
                                <div className='newslanding-top-latest-news-top-level'>
                                    <div className='newslanding-top-latest-news-top-card'></div>
                                    <div className='newslanding-top-latest-news-top-card'></div>
                                </div>
                                <div className='newslanding-top-latest-news-bottom-level'>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                </div>
                            </div>
                            <div className='newslanding-newsScreen-ad'>
                                <div className='newslanding-latest-news-ad'></div>
                            </div>
                        </div>
                        <div className='newslanding-latest-news-container display-on-desktop-only'>
                            <div className='newslanding-newsScreen-ad'>
                                <div className='newslanding-latest-news-ad'></div>
                            </div>
                            <div className='newslanding-top-latest-news-container'>
                                <div className='newslanding-top-latest-news-top-level'>
                                    <div className='newslanding-top-latest-news-top-card'></div>
                                    <div className='newslanding-top-latest-news-top-card'></div>
                                </div>
                                <div className='newslanding-top-latest-news-bottom-level'>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                </div>
                            </div>
                        </div>

                        <div className='newslanding-latest-news-container display-on-tablet-only'>
                            <div className='newlanding-latest-news-top-news'></div>
                            <div className='newslanding-top-latest-news-container'>
                                <div className='newslanding-top-latest-news-bottom-level'>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                </div>
                                <div className='newslanding-newsScreen-ad'>
                                    <div className='newslanding-latest-news-ad'></div>
                                </div>
                            </div>
                        </div>
                        <div className='newslanding-latest-news-container display-on-tablet-only'>
                            <div className='newlanding-latest-news-top-news'></div>
                            <div className='newslanding-top-latest-news-container'>
                                <div className='newslanding-newsScreen-ad'>
                                    <div className='newslanding-latest-news-ad'></div>
                                </div>
                                <div className='newslanding-top-latest-news-bottom-level'>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                    <div className='newslanding-top-latest-news-bottom-card'></div>
                                </div>
                            </div>
                        </div>

                        <div className='newslanding-latest-news-container display-on-mobile-only'>
                            <div className='newlanding-latest-news-top-news'></div>
                            <div className='newslanding-latest-news-container'>
                                <div className='newslanding-latest-news-ad'></div>
                                <div className='newlanding-latest-news-top-news'></div>
                                <div className='newlanding-latest-news-top-news'></div>
                                <div className='newlanding-latest-news-top-news'></div>
                            </div>
                        </div>
                        <div className='newslanding-latest-news-container display-on-mobile-only'>
                            <div className='newlanding-latest-news-top-news'></div>
                            <div className='newslanding-latest-news-container'>
                                <div className='newslanding-latest-news-ad'></div>
                                <div className='newlanding-latest-news-top-news'></div>
                                <div className='newlanding-latest-news-top-news'></div>
                                <div className='newlanding-latest-news-top-news'></div>
                            </div>
                        </div>

                    </div>

                    <div className='newslanding-view-more-container'>
                        <div className='newslanding-view-more-content'>
                            <div className='newslanding-view-more-title'>VIEW MORE</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};